import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import classNames from 'classnames';
import { BasicLinkPropType } from '@prospectus/common/types/commonPropTypes';
import LinkWithVisibilityTracking from '@prospectus/common/ui-strict/LinkWithVisibilityTracking';
import isUserLoggedIn from '@utils/user';

type TypeLinkListsView = {
  linkLists: Array<{
    heading: string;
    headingLink: string;
    links: Array<BasicLinkPropType>;
    lastEntryLink: BasicLinkPropType;
  }>;
  pageType: string;
};

function LinkListsView({ linkLists, pageType }: TypeLinkListsView) {
  const colLgClass = pageType === 'course' ? 'col-lg-3' : 'col-lg-4';
  return (
    <div className="container mb-5">
      <div className="row" data-cy={`${pageType}-container`}>
        {linkLists.map((linkList, index) => {
          const lastList = index === linkLists.length - 1;
          return (
            <div key={`${pageType}-link-list-${uuidv4()}`} className={`col col-12 col-md-6 ${colLgClass} mb-5`} data-cy={`${pageType}-list`}>
              <h4 className="h4">
                {linkList?.headingLink
                  ? (
                    <LinkWithVisibilityTracking
                      url={linkList.headingLink}
                      eventName={`edx.bi.user.mega-nav.${pageType}-view.link.clicked`}
                      additionalLinkProps={{
                        loggedIn: isUserLoggedIn(),
                        navigationLink: true,
                      }}
                    >
                      {linkList.heading}
                    </LinkWithVisibilityTracking>
                  )
                  : linkList.heading}
              </h4>
              {linkList.links.map((link, idx) => (
                <div
                  key={`${pageType}-link-${uuidv4()}`}
                  className={classNames(
                    'd-block small',
                    { 'last-cta': idx === linkList.links.length - 1 && lastList },
                  )}
                  data-cy={`${pageType}-link`}
                >
                  <LinkWithVisibilityTracking
                    url={link.url}
                    eventName={`edx.bi.user.mega-nav.${pageType}-view.link.clicked`}
                    additionalLinkProps={{
                      loggedIn: isUserLoggedIn(),
                      navigationLink: true,
                      category: link.label,
                    }}
                  >
                    {link.label}
                  </LinkWithVisibilityTracking>
                </div>
              ))}
              {linkList.lastEntryLink && (
                <LinkWithVisibilityTracking
                  className="font-weight-bold small"
                  url={linkList.lastEntryLink.url}
                  eventName={`edx.bi.user.mega-nav.${pageType}-view.link.clicked`}
                  additionalLinkProps={{
                    loggedIn: isUserLoggedIn(),
                    navigationLink: true,
                    category: linkList.lastEntryLink.label,
                  }}
                >
                  {linkList.lastEntryLink.label}
                </LinkWithVisibilityTracking>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default LinkListsView;
